import { useMountStore } from '@/state/useMountStore'
import { useShipStore } from '@/state/useShipStore'

export function MountPrompt() {
  const nearHorse = useMountStore((s) => s.nearHorse)
  const mounted = useMountStore((s) => s.mounted)
  const aboard = useShipStore((s) => s.aboard)

  if (!nearHorse || mounted || aboard) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: '120px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 100,
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      background: 'rgba(36, 24, 8, 0.88)',
      border: '1px solid #3a2a18',
      borderRadius: '2px',
      padding: '8px 16px',
      pointerEvents: 'none',
    }}>
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '28px',
        height: '24px',
        padding: '0 6px',
        background: '#3a2a18',
        border: '1px solid #4a3820',
        borderRadius: '2px',
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: '11px',
        fontWeight: 600,
        color: '#a89070',
      }}>H</span>
      <span style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '14px',
        color: '#c8b89a',
      }}>Mount Horse</span>
    </div>
  )
}
